module.exports = __webpack_public_path__ + "img/mailMessageUA.465ed1bf.png";